import React, { useEffect, useState } from "react";
import { Bell } from "lucide-react";
import { api } from "../lib/api";
import { Link } from "react-router-dom";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "./ui/dropdown-menu";

function timeAgo(iso) {
  try {
    const diff = (Date.now() - new Date(iso).getTime()) / 1000;
    if (diff < 60) return "baru saja";
    if (diff < 3600) return `${Math.floor(diff / 60)} menit lalu`;
    if (diff < 86400) return `${Math.floor(diff / 3600)} jam lalu`;
    return `${Math.floor(diff / 86400)} hari lalu`;
  } catch {
    return "";
  }
}

export default function NotificationBell() {
  const [data, setData] = useState({ count: 0, items: [] });

  const load = async () => {
    try {
      const res = await api.get("/reports/notifications");
      setData(res.data);
    } catch (_e) {
      /* ignore */
    }
  };

  useEffect(() => {
    load();
    const id = setInterval(load, 15000);
    return () => clearInterval(id);
  }, []);

  const markAll = async () => {
    try {
      await api.post("/reports/notifications/mark-all-read");
      await load();
    } catch (_e) {
      /* ignore */
    }
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          data-testid="notification-bell"
          className="relative inline-flex items-center justify-center h-10 w-10 rounded-md border border-slate-200 bg-white hover:bg-slate-50 transition-colors"
          aria-label="Notifikasi"
        >
          <Bell className="h-4 w-4 text-slate-700" />
          {data.count > 0 && (
            <span
              data-testid="notification-count"
              className="absolute -top-1 -right-1 min-w-[18px] h-[18px] px-1 rounded-full bg-red-500 text-[10px] font-bold text-white flex items-center justify-center pulse-dot"
            >
              {data.count > 99 ? "99+" : data.count}
            </span>
          )}
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-80">
        <div className="flex items-center justify-between px-2 py-1">
          <DropdownMenuLabel className="text-xs tracking-[0.2em] uppercase text-slate-500 p-0">
            Laporan Baru
          </DropdownMenuLabel>
          {data.count > 0 && (
            <button
              data-testid="mark-all-read-btn"
              onClick={markAll}
              className="text-[11px] font-semibold text-[#0B2B5E] hover:underline"
            >
              Tandai semua
            </button>
          )}
        </div>
        <DropdownMenuSeparator />
        {data.items.length === 0 && (
          <div className="px-4 py-8 text-center text-sm text-slate-500" data-testid="notification-empty">
            Tidak ada notifikasi baru
          </div>
        )}
        {data.items.map((n) => (
          <DropdownMenuItem asChild key={n.id} className="cursor-pointer">
            <Link
              to={`/admin/laporan/${n.id}`}
              data-testid={`notification-item-${n.id}`}
              className="flex flex-col gap-1 py-2"
            >
              <div className="flex items-center justify-between gap-2">
                <span className="text-xs font-mono-tight font-bold text-[#0B2B5E]">
                  {n.nomor_laporan}
                </span>
                <span className="text-[10px] text-slate-400">{timeAgo(n.created_at)}</span>
              </div>
              <div className="text-sm text-slate-700 truncate">
                {n.jenis_narkoba} • {n.kabupaten_kota}
              </div>
            </Link>
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
